import React from "react"
import Icon from "../../../components/AppIcon"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  SidebarTrigger,
} from "../../../components/ui/sidebar"

const NAV_SECTIONS = [
  {
    label: "Overview",
    items: [{ key: "overview", label: "Mission Control", icon: "LayoutDashboard" }],
  },
  {
    label: "Platform",
    items: [
      { key: "organizations", label: "Organizations", icon: "Building2" },
      { key: "people", label: "People", icon: "Users" },
      { key: "learning", label: "Learning", icon: "BookOpen" },
    ],
  },
  {
    label: "Credentialing",
    items: [{ key: "credentials", label: "Credentials & POL", icon: "Award" }],
  },
  {
    label: "Economy",
    items: [{ key: "economy", label: "Revenue & Orders", icon: "DollarSign" }],
  },
  {
    label: "Operations",
    items: [{ key: "operations", label: "Event Explorer", icon: "ScrollText" }],
  },
  {
    label: "Security",
    items: [{ key: "security", label: "Security & Governance", icon: "ShieldCheck" }],
  },
]

const ControlPlaneSidebar = ({ activeTab, onTabChange }) => {
  return (
    <Sidebar collapsible="icon" variant="sidebar" className="!top-16 !h-[calc(100svh-4rem)]">
      <SidebarHeader className="flex-row items-center justify-between gap-2 border-b border-sidebar-border py-3">
        <span className="text-xs font-mono text-sidebar-foreground/70 truncate group-data-[collapsible=icon]:hidden">
          NESOLEARN CONTROL PLANE
        </span>
        <SidebarTrigger />
      </SidebarHeader>

      <SidebarContent>
        {NAV_SECTIONS?.map((section) => (
          <SidebarGroup key={section?.label}>
            <SidebarGroupLabel>{section?.label}</SidebarGroupLabel>
            <SidebarMenu>
              {section?.items?.map((item) => (
                <SidebarMenuItem key={item?.key}>
                  <SidebarMenuButton
                    isActive={activeTab === item?.key}
                    tooltip={item?.label}
                    onClick={() => onTabChange(item?.key)}
                  >
                    <Icon name={item?.icon} size={16} />
                    <span>{item?.label}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroup>
        ))}
      </SidebarContent>

      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton tooltip="All systems operational" className="cursor-default">
              <span className="size-2 rounded-full bg-success shrink-0" />
              <span className="truncate">All systems operational</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  )
}

export default ControlPlaneSidebar